export const APPLICATION_INSIGHT_CONNECTION_STRING = import.meta.env.VITE_APPLICATION_INSIGHT_CONNECTION_STRING
export const AUTHENTICATE_API_BASE_URL = import.meta.env.VITE_AUTHENTICATE_API_BASE_URL || ''
export const RECAPTCHA_CLIENT_KEY = import.meta.env.VITE_RECAPTCHA_CLIENT_KEY || ''
export const LOGROCKET_TOKEN = import.meta.env.VITE_LOGROCKET_TOKEN || ''
export const BROWSER_ROUTER_BASENAME = import.meta.env.VITE_BROWSER_ROUTER_BASENAME
export const MIDDLEWARE_GRAPHQL_URL =
  import.meta.env.VITE_MIDDLEWARE_GRAPHQL_URL || 'https://devdevelopers.mdvip.com/graphql'
export const ASSETS_URL = import.meta.env.VITE_ASSETS_URL || ''
